import type { BariPostDietConsultReportData } from '@common/validation/customControls/bariPost/bariPostDietConsultReport/v1/bariPostDietConsultReportSchemaV1';
import { CustomControlCode } from '@common/enums';
import { CustomControlRegistry } from '@frontend/components/pages/episodeCategory/customControls/customControlRegistry';
import { initialData } from './bariPostDietConsultReportData';
import { BariPostDietConsultReportEdit } from './BariPostDietConsultReportEdit';
import { BariPostDietConsultReportRead } from './BariPostDietConsultReportRead';

CustomControlRegistry.instance.register<BariPostDietConsultReportData>({
    EditElement: BariPostDietConsultReportEdit,
    ReadElement: BariPostDietConsultReportRead,
    canCopyReadSections: true,
    code: CustomControlCode.BariPostDietConsultReport,
    initialData,
    version: 1,
});
